<template>
    <span v-if="object" class="object-responsibles" :class="{'on-dark': dark}" title="Текущие ответственные объекта">
        <span>Прораб: <EmployeeLink v-if="object.foreman" :user-id="object.foreman.user_id" :fallback="object.foreman.name" compact open-in-panel /><span v-else>Не назначен</span></span>
        <span>Куратор: <EmployeeLink v-if="object.curator" :user-id="object.curator.user_id" :fallback="object.curator.name" compact open-in-panel /><span v-else>Не назначен</span></span>
    </span>
</template>
<script>
import EmployeeLink from '@/components/EmployeeLink.vue';
export default {
    components: {EmployeeLink},
    props: {objects: {type: Array, default: () => []}, buildingId: {type: [String, Number], required: true}, dark: Boolean},
    computed: {object() { return this.objects.find(item => Number(item.building_id) === Number(this.buildingId)); }}
};
</script>
<style scoped>
.object-responsibles.object-responsibles { display: inline-flex; flex-wrap: wrap; align-items: baseline; gap: 4px 16px; font-size: 12px; font-weight: 400; line-height: 1.5; }
.object-responsibles.object-responsibles > span { display: inline; }
.on-dark { color: #e5e7eb; }
.on-dark >>> .employee-link { color: #fff; }
.on-dark >>> .employee-link:focus-visible { outline: 2px solid #fff; outline-offset: 3px; }
</style>
